import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <motion.button whileHover={{
    opacity: 0.9
  }} whileTap={{
    scale: 0.98
  }} transition={{
    duration: 0.15,
    ease: 'easeInOut'
  }} className={`${`${`${`bg-charcoal hover:bg-charcoal-light text-cream font-medium py-4 px-8 rounded-lg shadow-sm transition-colors duration-200 text-lg md:text-xl tracking-wide ${className}`} bg-[#C89513]`} bg-[#D49E17]`} bg-[#D49E17]`} {...props} onClick={e => {
    props.onClick?.(e);
    const target = document.getElementById('precio-final');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} data-id="element-14">
      {children}
    </motion.button>;
}